import { render, staticRenderFns } from "./SanitaryGridTab.vue?vue&type=template&id=a29b3010&scoped=true"
import script from "./SanitaryGridTab.vue?vue&type=script&lang=js"
export * from "./SanitaryGridTab.vue?vue&type=script&lang=js"
import style0 from "./SanitaryGridTab.vue?vue&type=style&index=0&id=a29b3010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29b3010",
  null
  
)

export default component.exports